import { IFunctionCard } from '@/pages/home/interface/home.interface';
import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';
import { FUNC_HASH_MAIN } from '@/pages/function/constants/index';

interface FunctionCardProps {
	items: IFunctionCard[];
}

/**
 * 올인원 비즈니스웨어 스타트업, 성장기업을 위해 최적화된 ERP 스텔라 주요 기능 카드 컴포넌트
 * @param props: IFunctionCard
 * @returns JSX.Element
 */

const FunctionCard = ({ items }: FunctionCardProps) => {
	return (
		<>
			{items.map((item, index) => {
				const hash = FUNC_HASH_MAIN.includes(item.type) ? `#${item.type}` : '';
				return (
					<li key={index} className={`card-item ${item.isComingSoon ? 'soon' : ''} ${item.blank ? 'blank' : ''}`}>
						{item.isComingSoon || item.blank ? (
							<span>
								<div className={`icon-holder ${item.icoNum}`}>
									<i></i>
								</div>
								<div className="title-group">
									<strong className="title">{item.title}</strong>
									<p className="desc" dangerouslySetInnerHTML={{ __html: item.description }}></p>
								</div>
							</span>
						) : (
							<Link to={`${NAV_PATH.FUNCTION.MAIN}${hash}`}>
								<div className={`icon-holder ${item.icoNum}`}>
									<i></i>
								</div>
								<div className="title-group">
									<strong className={`title ${item.new ? 'new' : ''} ${item.beta ? 'beta' : ''}`}>{item.title}</strong>
									<p className="desc" dangerouslySetInnerHTML={{ __html: item.description }}></p>
								</div>
							</Link>
						)}
					</li>
				);
			})}
		</>
	);
};

export default FunctionCard;
